module.exports = __webpack_public_path__ + "static/media/CARTA DE DERCHOS MÍNIMOS DOF 06.07.2015 (1).6f6dd347.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/CARTA DE DERCHOS MÍNIMOS DOF 06.07.2015 (1).pdf
// module id = 787
// module chunks = 0